import React from 'react';
import {
  EligibilityOverviewEncounter,
} from 'dtos/eligibilityOverviewEncounter';
import Tag from 'core/components/Tag';
import Section from 'views/EMR/components/Eligibility/Overview/Section';
import isNil from 'lodash/isNil';

type Props = {
  encounter: EligibilityOverviewEncounter;
};

export default function Encounter({ encounter }: Props) {
  const { serviceTypeCodes } = encounter;

  return !isNil(serviceTypeCodes) && serviceTypeCodes.length > 0 ? (
    <Section title="Encounter">
      <div className="flex flex-col gap-0.5">
        <span className="text-xs text-gray-500">Service type codes</span>
        <div className="flex flex-wrap gap-1.5 mt-1">
          {serviceTypeCodes.map((code) => (
            <Tag
              key={code}
              defaultColor="bg-gray-100 text-gray-700 cursor-default"
              className="!font-semibold"
            >
              {code}
            </Tag>
          ))}
        </div>
      </div>
    </Section>
  ) : null;
}
